"use strict";

import React from 'react';
import AppStore from '../stores/AppStore';

/**
 * Web 11: the transfer has failed more than once. The screen carries no action,
 * so the customer's only route onwards is the support number in the message.
 */
export default class MigrationMultiFailed extends React.Component {
    render() {
        return (
            <div className="migration-outcome-overlay">
                <h1 className="migration-outcome-overlay__lead">
                    {AppStore.translate('view.account_migration_page.migration_message.error')}
                </h1>
            </div>
        );
    }
}
